import classNames from 'classnames'
import { motion } from 'framer-motion'
import React, { JSX } from 'react'

import styles from './InventoryPager.module.scss'

interface InventoryPagerProps {
  children: React.ReactNode
  value: number
  animatedAxis: 'x' | 'y'
  onChange(index: number): void
}

const DRAG_THRESHOLD = 20

export const InventoryPager = ({
  children,
  value,
  animatedAxis,
  onChange,
}: InventoryPagerProps): JSX.Element => {
  return (
    <div
      className={classNames(
        styles.inventoryPager,
        animatedAxis === 'y' && styles.isY,
        animatedAxis === 'x' && styles.isX
      )}
    >
      <motion.div
        className={classNames(
          styles.animated,
          animatedAxis === 'y' && styles.isY,
          animatedAxis === 'x' && styles.isX,
          value === 1 && styles.isSecond,
          value === 2 && styles.isThird
        )}
      >
        {React.Children.map(children, (child, i) => (
          <motion.div
            className={styles.inner}
            key={i}
            animate={{ opacity: i === value ? 1 : 0.5 }}
          >
            {child}
          </motion.div>
        ))}
      </motion.div>
    </div>
  )
}
